class ToggleMobileMenu extends HTMLElement {
  constructor() {
    super();
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
  }
  toggleMenu() {
    const menu = document.querySelector("#MobileMenu");
    if (menu) {
      menu.classList.toggle("active");
    }
  }

  handleKeyDown(e) {
    if (e.key === "Escape" || e.key === "Esc") {
      const menu = document.querySelector("#MobileMenu");
      if (menu?.classList.contains("active")) {
        this.toggleMenu();
      }
    }
  }

  connectedCallback() {
    this.addEventListener("click", this.toggleMenu);
    document.addEventListener("keydown", this.handleKeyDown);
  }

  disconnectedCallback() {
    this.removeEventListener("click", this.toggleMenu);
    document.removeEventListener("keydown", this.handleKeyDown);
  }
}
customElements.define("toggle-mobile-menu", ToggleMobileMenu);
